import { Base } from "ui/Scripts/source/framework/base";
import { CalendarTaskItems, ICalendarTaskItems } from "ui/Scripts/source/models/calendarTask/calendarTaskItems";
import { CalendarTaskCategoryListItem, ICalendarTaskCategoryListItem } from "ui/Scripts/source/models/calendarTaskCategory/calendarTaskCategoryListItem";

export interface IMobileCalendarTaskItems extends ICalendarTaskItems {
    categories: ICalendarTaskCategoryListItem[];
}

export class MobileCalendarTaskItems extends CalendarTaskItems implements IMobileCalendarTaskItems {
    categories: CalendarTaskCategoryListItem[];

    constructor();
    constructor(obj: IMobileCalendarTaskItems);
    constructor(obj?: any) {
        super(obj);
        this.categories = Base.getTypedArray(obj ? obj.categories : null, CalendarTaskCategoryListItem);
    }
}